import PropCreate from "../components/propcreate/propcreate";
function Proposalcreate(){
    return(
        <>
        <PropCreate/>
        </>
    )
}
export default Proposalcreate